export default "__VITE_ASSET__B2dnnYwy__"